var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68 5.68C4 7.376 4 10.088 4 15.52V16.48C4 21.904 4 24.616 5.68 26.32C7.376 28 10.088 28 15.52 28H16.48C21.904 28 24.616 28 26.32 26.32C28 24.624 28 21.912 28 16.48V15.52C28 10.096 28 7.384 26.32 5.68C24.624 4 21.912 4 16.48 4H15.52C10.096 4 7.384 4 5.68 5.68ZM8.04817 11.3042H10.8002C10.8882 15.8803 12.9042 17.8163 14.5041 18.2163V11.3042H17.0881V15.2483C18.6641 15.0803 20.3281 13.2802 20.8881 11.2962H23.4641C23.2541 12.3232 22.8345 13.2959 22.2316 14.1535C21.6288 15.0109 20.8555 15.7349 19.9601 16.2803C20.9593 16.7775 21.8417 17.4809 22.5491 18.3443C23.2565 19.2075 23.7729 20.2108 24.0641 21.2883H21.2241C20.6161 19.3923 19.0961 17.9203 17.0881 17.7203V21.2883H16.7761H16.7681C11.2962 21.2883 8.17617 17.5443 8.04817 11.3042Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/VkIcon.d59b91bc278afebb0494780ca4718c19.svg";
export { ForwardRef as ReactComponent };